/** @format */

import React, { FunctionComponent, ReactElement } from 'react';
import MvnoOperation from '../../interfaces/platform/MvnoOperation';

export type OplFunctionsType = {
    mvnoOperation: MvnoOperation;
    viewDialog(title: any | string | null, content: any | null): void;
};

export const OplFunctions: FunctionComponent<OplFunctionsType> = ({ mvnoOperation, viewDialog }): ReactElement | null => {
    switch (mvnoOperation.command) {
        default:
            return null;
    }
};
